module.exports = __webpack_public_path__ + "assets/imgs/logos/microsoftAd.8145775997feafd45a3e4a580b867b60.png";